module.exports = __webpack_public_path__ + "static/media/IMG_3559-min.1b76f46f.JPG";